/**
 * `bootstrap-multiselect` is loaded via a standalone <script> tag that comes
 * AFTER the SPA bundle in resources/views/app.blade.php. When a Vue component
 * mounts during initial bundle execution (e.g. the route matches on first
 * render with no auth redirect), the plugin may not yet be registered on
 * `jQuery.fn`. This helper polls briefly until `$.fn.multiselect` is available
 * and then invokes the callback. Resolves to a no-op after `timeoutMs` if the
 * plugin never loads (e.g. blocked by a content blocker).
 */
export default function whenMultiselectReady(callback, { timeoutMs = 5000, intervalMs = 25 } = {}) {
  const start = Date.now();

  const tryRun = () => {
    if (window.jQuery && window.jQuery.fn && typeof window.jQuery.fn.multiselect === 'function') {
      callback();
      return;
    }
    if (Date.now() - start >= timeoutMs) {
      // eslint-disable-next-line no-console
      console.warn('whenMultiselectReady: $.fn.multiselect never became available');
      return;
    }
    setTimeout(tryRun, intervalMs);
  };

  tryRun();
}
